/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FeeOption } from './FeeOption';
import {
    FeeOptionFromJSON,
    FeeOptionFromJSONTyped,
    FeeOptionToJSON,
} from './FeeOption';

/**
 * 
 * @export
 * @interface TenantAdministeredDrug
 */
export interface TenantAdministeredDrug {
    /**
     * Stable entry id, server-assigned when absent. Referenced by the charge flow (feeEntryId).
     * @type {string}
     * @memberof TenantAdministeredDrug
     */
    id?: string;
    /**
     * Unique per tenant (case-insensitive).
     * @type {string}
     * @memberof TenantAdministeredDrug
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAdministeredDrug
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAdministeredDrug
     */
    route?: string;
    /**
     * 
     * @type {Array<FeeOption>}
     * @memberof TenantAdministeredDrug
     */
    fees?: Array<FeeOption>;
}

/**
 * Check if a given object implements the TenantAdministeredDrug interface.
 */
export function instanceOfTenantAdministeredDrug(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function TenantAdministeredDrugFromJSON(json: any): TenantAdministeredDrug {
    return TenantAdministeredDrugFromJSONTyped(json, false);
}

export function TenantAdministeredDrugFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantAdministeredDrug {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'fees': !exists(json, 'fees') ? undefined : ((json['fees'] as Array<any>).map(FeeOptionFromJSON)),
    };
}

export function TenantAdministeredDrugToJSON(value?: TenantAdministeredDrug | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'route': value.route,
        'fees': value.fees === undefined ? undefined : ((value.fees as Array<any>).map(FeeOptionToJSON)),
    };
}

